import CssBaseLine from '@material-ui/core/CssBaseline';
import React, { FC } from 'react';
import HostPage from './pages/host.page';
// import svgUrl from "./components/logo_white.svg";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    position: "fixed",
    top: 0,
    bottom: 0,
    background: "#EEEEEE",
    backgroundImage: `url(./logo_white.svg)`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  },
  sub: {
    position: "absolute",
    width: "100%",
    top: 0,
    bottom: 0,
    overflowY: "auto"
  }
}));

const App: FC = (props) => {

  const classes = useStyles(props);

  return (
    <>
      <CssBaseLine />
      <div className={classes.root}>
        <div className={classes.sub}>
          <HostPage />
        </div>
      </div>
    </>
  )
}

export default App;
